/* eslint-disable import/no-default-export */
import { createRoot } from 'react-dom/client';
import { UIDProvider } from 'dibs-uid';
export default function makeOfferLauncher(options = {}) {
    const modalContainer = document.createElement('div');
    const {
        currency,
        itemId,
        selectedSkuId,
        environment,
        quantitySelected,
        shouldNotSendOfferMessage,
        launchOrigin,
        shouldLaunchContactDealer,
    } = options;
    return import(
        /* webpackChunkName: "makeOfferModal" */
        '../src/MakeOfferModal/makeOfferAsyncImports'
    ).then(mod => {
        const { components, helpers } = mod;

        const { MakeOfferModal, IntlProvider } = components;
        const { serverVars } = helpers;
        const root = createRoot(modalContainer);

        root.render(
            <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
                <UIDProvider prefix="offerModal">
                    <MakeOfferModal
                        launchOrigin={launchOrigin}
                        environment={environment}
                        itemId={itemId}
                        selectedSkuId={selectedSkuId}
                        pageCurrency={currency}
                        quantitySelected={quantitySelected}
                        shouldNotSendOfferMessage={shouldNotSendOfferMessage}
                        shouldLaunchContactDealer={shouldLaunchContactDealer}
                    />
                </UIDProvider>
            </IntlProvider>
        );
    });
}
